import React from 'react';
import { Trophy, X } from 'lucide-react';
import { Button } from './Button';
interface CompletedProgramModalProps {
  onBuildNext: () => void;
  onLater: () => void;
}
export function CompletedProgramModal({
  onBuildNext,
  onLater
}: CompletedProgramModalProps) {
  return <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-in fade-in duration-200" data-id="element-86">
      <div className="bg-white w-full max-w-sm rounded-[2.5rem] p-6 shadow-2xl animate-in zoom-in-95 duration-200 relative" data-id="element-87">
        <button onClick={onLater} className="absolute top-4 right-4 p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-full transition-colors" data-id="element-88">
          <X size={20} data-id="element-89" />
        </button>

        <div className="w-20 h-20 rounded-3xl overflow-hidden border-4 border-white shadow-md bg-stone-200 mb-5 mx-auto" data-id="element-90">
          <video autoPlay loop muted playsInline className="w-full h-full object-cover" src="https://cdn.magicpatterns.com/uploads/69mUG6ooMsKbP89Ta37mkt/Katethought_friendly_gym_mascot_character_funny_good_guy_musc_bc3cfd10-111a-4766-8e76-81af2852edc8_2.mp4" data-id="element-91" />
        </div>

        <div className="w-10 h-10 bg-emerald-50 text-emerald-500 rounded-full flex items-center justify-center mb-4 mx-auto" data-id="element-92">
          <Trophy size={22} data-id="element-93" />
        </div>

        <div className="text-center mb-6" data-id="element-94">
          <h2 className="text-2xl font-extrabold text-slate-800 mb-3" data-id="element-95">
            Program completed
          </h2>
          <p className="text-slate-600 font-medium text-sm leading-relaxed mb-3" data-id="element-96">
            Your current program has reached the end of its planned duration.
          </p>
          <p className="text-slate-600 font-medium text-sm leading-relaxed" data-id="element-97">
            Would you like to build your next program now?
          </p>
        </div>

        <p className="text-xs font-medium text-slate-400 text-center leading-relaxed mb-6" data-id="element-98">
          You'll choose your training days first, then review your recommended
          structure and start date.
        </p>

        <div className="space-y-3" data-id="element-99">
          <Button variant="primary" fullWidth onClick={onBuildNext} data-id="element-100">
            Build my next program
          </Button>
          <Button variant="outline" fullWidth onClick={onLater} data-id="element-101">
            Later
          </Button>
        </div>
      </div>
    </div>;
}